"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupInstance = setupInstance;
const React = __importStar(require("react"));
const components_1 = require("@smapiot/components");
const piral_core_1 = require("piral-core");
const piral_breadcrumbs_1 = require("piral-breadcrumbs");
const piral_modals_1 = require("piral-modals");
const UserLayout_1 = require("./layout/UserLayout");
const ModalsHost_1 = require("./components/ModalsHost");
const http_1 = require("./http");
const routes_1 = require("./routes");
const plugins_1 = require("./plugins");
function setupInstance(user) {
    const instance = (0, piral_core_1.createInstance)({
        plugins: [
            (0, piral_breadcrumbs_1.createBreadcrumbsApi)({ breadcrumbs: routes_1.breadcrumbs }),
            (0, piral_modals_1.createModalsApi)(),
            (0, plugins_1.createCloudPortalApi)(user),
        ],
        state: {
            components: {
                LoadingIndicator: components_1.Spinner,
                BreadcrumbItem: components_1.BreadcrumbItem,
                BreadcrumbsContainer: components_1.BreadcrumbsContainer,
                Layout: UserLayout_1.Layout,
                ModalsHost: ModalsHost_1.ModalsHost,
                ModalsDialog: components_1.ModalsDialog,
            },
            errorComponents: {
                not_found: components_1.NotFound,
                page: React.lazy(() => Promise.resolve().then(() => __importStar(require('./pages/PageError')))),
            },
            routes: {
                [routes_1.routes.home]: null,
                [routes_1.routes.noauth]: React.lazy(() => Promise.resolve().then(() => __importStar(require('./pages/NoAccess')))),
                [routes_1.routes.notifications]: React.lazy(() => Promise.resolve().then(() => __importStar(require('./pages/Notifications')))),
                [routes_1.routes.privacy]: React.lazy(() => Promise.resolve().then(() => __importStar(require('./pages/Privacy')))),
                [routes_1.routes.terms]: React.lazy(() => Promise.resolve().then(() => __importStar(require('./pages/Terms')))),
                [routes_1.routes.imprint]: React.lazy(() => Promise.resolve().then(() => __importStar(require('./pages/Imprint')))),
            },
        },
        requestPilets() {
            return (0, http_1.loadPilets)();
        },
    });
    return instance;
}
